import { Navigate, Route, Routes } from "react-router-dom";
import { getTenantSlugFromHost } from "./site-context";
import { LandingPage } from "./pages/Landing";
import { SignupPage } from "./pages/Signup";
import { LoginPage } from "./pages/Login";
import { OwnerShell } from "./pages/OwnerShell";
import { OverviewPage } from "./pages/Overview";
import { OnboardingPage } from "./pages/Onboarding";
import { WebsitePage } from "./pages/Website";
import { ServicesPage } from "./pages/Services";
import { BookingsPage } from "./pages/Bookings";
import { ClientsPage } from "./pages/Clients";
import { SettingsPage } from "./pages/Settings";
import { AiAssistantPage } from "./pages/AiAssistant";
import { DataOwnershipPage } from "./pages/DataOwnership";
import { PublicSitePage } from "./pages/PublicSite";
import { SiteLoginPage } from "./pages/SiteLogin";
import { SiteRegisterPage } from "./pages/SiteRegister";
import { SiteBookPage } from "./pages/SiteBook";
import { SitePortalPage } from "./pages/SitePortal";

function TenantSiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PublicSitePage />} />
      <Route path="/login" element={<SiteLoginPage />} />
      <Route path="/register" element={<SiteRegisterPage />} />
      <Route path="/book" element={<SiteBookPage />} />
      <Route path="/portal" element={<SitePortalPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PlatformRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/app" element={<OwnerShell />}>
        <Route index element={<OverviewPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="website" element={<WebsitePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="ai" element={<AiAssistantPage />} />
        <Route path="data" element={<DataOwnershipPage />} />
      </Route>

      <Route path="/site/:slug" element={<PublicSitePage />} />
      <Route path="/site/:slug/login" element={<SiteLoginPage />} />
      <Route path="/site/:slug/register" element={<SiteRegisterPage />} />
      <Route path="/site/:slug/book" element={<SiteBookPage />} />
      <Route path="/site/:slug/portal" element={<SitePortalPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return getTenantSlugFromHost() ? <TenantSiteRoutes /> : <PlatformRoutes />;
}
